import {appendAll} from "../utils/helpers";

const LAMMediaCards = () => {
  const liquidData = JSON.parse(
    document.getElementById(`lam-media-cards-metafields`).textContent
  );

  appendAll(liquidData);
}

export default LAMMediaCards;